/* globals Image */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.inspirationFilter = (function () {
    const initialize = function () {
      const $grid = $('#inspirationGalleryDiv')
      if ($grid.length === 0) {
        return
      }

      const gallery = eah.gallery || null

      $('.inspirationGalleryDiv .js-controlLink').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        const desiredLook = $(this).attr('data-img-filter-button')

        $this.closest('.wrap').find('.grid').removeAttr('id').attr('id', desiredLook)
        $this.parent().addClass('is-selected').siblings().removeClass('is-selected')

        matchImages(gallery)
      })

      // go ahead and preload all images for this gallery
      if (gallery) {
        for (let key in gallery) {
          if (gallery.hasOwnProperty(key)) {
            let img = new Image()
            img.src = gallery[ key ].image_url
          }
        }
      }

      matchImages(gallery)
    }

    function matchImages (gallery) {
      const currentGallery = $('.grid').attr('id')
      const pinterestLink = 'https://www.pinterest.com/pin/create/button/?url={url}&media={media}&description={description}'

      // allow all gallery images to be grouped together in lightbox
      $('.grid').find('a.imageLink').attr('rel', currentGallery)

      // dynamically alter the content based on which filter you are on
      $.each($('.grid .bgImage'), function () {
        const $this = $(this)
        const $parent = $this.parents('.basicImage')
        const index = $parent.index()
        const $link = $this.parent('a')
        const $caption = $parent.find('.description')
        const $download = $parent.find('a.download')
        const $pinterest = $parent.find('.shareOnPinterest > a') // this is because Pinterest API removes the .pinterest class
        const galleryInfo = gallery[ currentGallery + '-' + index ]
        const theUrl = encodeURIComponent(window.location.href)
        const theMedia = encodeURIComponent(galleryInfo.image_url)
        const theDescription = encodeURIComponent(galleryInfo.caption).replace(/[!'()]/g, escape).replace(/\*/g, '%2A')

        $pinterest.attr('data-url', theUrl)
        $pinterest.attr('data-media', theMedia)
        $pinterest.attr('data-description', theDescription)

        let pinterest = pinterestLink.replace('{url}', theUrl)
        pinterest = pinterest.replace('{media}', theMedia)
        pinterest = pinterest.replace('{description}', theDescription)

        // update everything with above data
        $link.attr('href', galleryInfo.image_url)
        $download.attr('href', theMedia)
        $caption.html(galleryInfo.caption)
        $pinterest.attr('href', pinterest)
        $pinterest.attr('data-pin-shape', 'round')
      })

      eah.pinterest.reload() // have to reload the pinterest JS
      if (typeof window.parsePinBtns === 'function') {
        window.parsePinBtns() // now have pinterest reload the buttons
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.inspirationFilter.initialize()
  })
}(jQuery, window))
